import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import api from "../services/api";
import "./BenefitsPage.css";

const BenefitsPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [plans, setPlans] = useState({ health: [], dental: [], vision: [] });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [editInputs, setEditInputs] = useState({});
    

    const fetchPlans = useCallback(async () => {
        try {
          const { data } = await api.get(`/benefit-plans/${id}`);
          const grouped = { health: [], dental: [], vision: [] };
      
          data.forEach((plan) => {
            if (grouped[plan.type]) {
              grouped[plan.type].push(plan);
            }
          });
      
          setPlans(grouped);
        } catch (err) {
          console.error("Failed to load benefit plans:", err);
          setError("Unable to fetch benefit plans.");
        } finally {
          setLoading(false);
        }
      }, [id]); // dependency for useCallback
      
      
      useEffect(() => {
        fetchPlans();
      }, [fetchPlans]);
      
      

    const routeMap = {
        health: `/dashboard/business/${id}/benefits-setup`,
        dental: `/dashboard/business/${id}/benefits-dental`,
        vision: `/dashboard/business/${id}/benefits-vision`,
    };


    const handleEditToggle = (planId) => {
        if (editingId === planId) {
          setEditingId(null);
          setEditInputs({});
        } else {
          setEditingId(planId);
          setEditInputs({});
        }
      };
      
      const handleEditChange = (e, field) => {
        const value = e.target.value;
      
        setEditInputs((prev) => {
          const updated = { ...prev, [field]: value };
      
          // Auto-calculate the complementary % to keep the total at 100
          if (field === "employee_contribution") {
            const num = parseFloat(value);
            if (!isNaN(num)) {
              updated["employer_contribution"] = (100 - num).toFixed(2);
            }
          } else if (field === "employer_contribution") {
            const num = parseFloat(value);
            if (!isNaN(num)) {
              updated["employee_contribution"] = (100 - num).toFixed(2);
            }
          }
      
          return updated;
        });
      };
      
      
      const handleEditSubmit = async (planId) => {
        const emp = parseFloat(editInputs.employee_contribution);
        const er = parseFloat(editInputs.employer_contribution);
      
        // Validate only if both values are being updated
        if (
          editInputs.employee_contribution !== undefined &&
          editInputs.employer_contribution !== undefined
        ) {
          if (
            isNaN(emp) || isNaN(er) ||
            Math.abs(emp + er - 100) > 0.01
          ) {
            alert("Employee % and Employer % must add up to 100%");
            return;
          }
        }
      
        const payload = {};
        for (const key in editInputs) {
          if (editInputs[key] !== "") {
            payload[key] = editInputs[key];
          }
        }
      
        try {
          await api.put(`/benefit-plans/${planId}`, payload);
          alert("Plan updated!");
          setEditingId(null);
          setEditInputs({});
          fetchPlans(); // refetch updated plans
        } catch (err) {
          console.error("Update failed", err);
          alert("Failed to update plan.");
        }
      };
      
      
      

    const renderTable = (type, plansOfType) => (
        <div className="benefit-section">
            <h3>{type.charAt(0).toUpperCase() + type.slice(1)} Plans</h3>
            <button
                className="add-plan-button"
                onClick={() => navigate(routeMap[type])}
            >
                Add New {type.charAt(0).toUpperCase() + type.slice(1)} Plan
            </button>
            <div className="table-container-benefits">
                <table className="benefits-table">
                    <thead>
                        <tr>
                            <th className="head-plan-name">Plan Name</th>
                            <th className="head-carrier">Carrier</th>
                            <th className="head-benefits">Employee %</th>
                            <th className="head-benefits">Employer %</th>
                            <th className="head-benefits">Employee Only</th>
                            <th className="head-benefits">+ Spouse</th>
                            <th className="head-benefits">+ Children</th>
                            <th className="head-benefits">Family</th>
                        </tr>
                    </thead>
                    <tbody>
                        {plansOfType.map((plan) => (
                            <React.Fragment key={plan.id}>
                    <tr>
                        
                        <td>
                        {plan.plan_name}
                
                        </td>
                        <td>{plan.carrier_name} {plan.logo_url && <img src={plan.logo_url} alt="Logo" height={24} />}</td>
                        <td>{plan.employee_contribution}%</td>
                        <td>{plan.employer_contribution}%</td>
                        <td>${plan.cost_employee_only}</td>
                        <td>${plan.cost_employee_spouse}</td>
                        <td>${plan.cost_employee_children}</td>
                        <td>${plan.cost_family}</td>
                        <FaEdit
                            className="ms-2 text-primary"
                            style={{ cursor: "pointer", marginTop:'15px', fontSize:'20px' }}
                            onClick={() => handleEditToggle(plan.id)}
                            title="Edit Plan"
                        />
                        
                    </tr>
                    
                    {editingId === plan.id && (
                        <tr>
                            <td colSpan={8}>
                            <div className="d-flex flex-wrap gap-2">
                                
                                <input
                                placeholder="Employee %"
                                value={editInputs.employee_contribution || ""}
                                onChange={(e) => handleEditChange(e, "employee_contribution")}
                                className="form-control"
                                style={{ width: "85px", marginLeft:"400px", marginRight:'5px' }}
                                />
                                <input
                                placeholder="Employer %"
                                value={editInputs.employer_contribution || ""}
                                onChange={(e) => handleEditChange(e, "employer_contribution")}
                                className="form-control"
                                style={{ width: "85px", marginRight:'5px' }}
                                />
                                <input
                                placeholder="Employee Only"
                                value={editInputs.cost_employee_only || ""}
                                onChange={(e) => handleEditChange(e, "cost_employee_only")}
                                className="form-control"
                                style={{ width: "85px" , marginRight:'5px'}}
                                />
                                <input
                                placeholder="+ Spouse"
                                value={editInputs.cost_employee_spouse || ""}
                                onChange={(e) => handleEditChange(e, "cost_employee_spouse")}
                                className="form-control"
                                style={{ width: "85px", marginRight:'5px' }}
                                />
                                <input
                                placeholder="+ Children"
                                value={editInputs.cost_employee_children || ""}
                                onChange={(e) => handleEditChange(e, "cost_employee_children")}
                                className="form-control"
                                style={{ width: "85px", marginRight:'5px' }}
                                />
                                <input
                                placeholder="Family"
                                value={editInputs.cost_family || ""}
                                onChange={(e) => handleEditChange(e, "cost_family")}
                                className="form-control"
                                style={{ width: "85px" }}
                                />
                                
                                
                            </div>
                            <button className="btn btn-sm btn-success" onClick={() => handleEditSubmit(plan.id)}>
                                Save
                                </button>
                                <button className="btn btn-sm btn-secondary" onClick={() => handleEditToggle(null)}>
                                Cancel
                                </button>
                            </td>
                        </tr>
                        )}

                    </React.Fragment>

                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );

    if (loading) return <p>Loading benefit plans...</p>;
    if (error) return <p className="error">{error}</p>;

    return (
        <div className="benefits-page">
        <div className="tile">
                  
                    <div className="tile-body">
                      <div className="tile-title">401k / IRA</div>
                      <div className="tile-sub">Not Set Up</div>
                    </div>
                    <button className="user-pro-link" onClick={() => navigate(`/dashboard/business/${id}/retirement-setup`)}>
                      Set Up
                    </button>
                  </div>

            {["health", "dental", "vision"].map((type) => {
                const label = type.charAt(0).toUpperCase() + type.slice(1);

                return (
                    <div className="no-plan-container" key={type}>
                        {plans[type].length > 0 ? (
                            renderTable(type, plans[type])
                        ) : (
                            <div className="no-plan-container">
                                <h3>{label} Plans</h3>
                                <p className="no-plans">No {label.toLowerCase()} plans available.</p>
                                <button
                                    className="add-plan-button"
                                    onClick={() => navigate(routeMap[type])}
                                >
                                    Add {label} Plan
                                </button>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default BenefitsPage;





// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import api from "../services/api";
// import "./BenefitsPage.css";

// const BenefitsPage = () => {
//     const { id: businessId } = useParams();
//     const [plans, setPlans] = useState({ health: [], dental: [], vision: [] });
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState("");

//     useEffect(() => {
//         const fetchPlans = async () => {
//             try {
//                 const { data } = await api.get(`/benefit-plans/${businessId}`);
//                 const grouped = { health: [], dental: [], vision: [] };

//                 data.forEach((plan) => {
//                     if (grouped[plan.type]) {
//                         grouped[plan.type].push(plan);
//                     }
//                 });

//                 setPlans(grouped);
//             } catch (err) {
//                 console.error("Failed to load benefit plans:", err);
//                 setError("Unable to fetch benefit plans.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchPlans();
//     }, [businessId]);

//     const renderPlanCard = (plan) => (
//         <div key={plan.id} className="benefit-card">
//             <div className="card-header-benefit">
//                 <h4>{plan.plan_name}</h4>
//                 {plan.logo_url && <img src={plan.logo_url} alt="Carrier Logo" height={30} />}
//             </div>
//             <p><strong>Carrier:</strong> {plan.carrier_name}</p>
//             <p><strong>Employee Contribution:</strong> {plan.employee_contribution}%</p>
//             <p><strong>Employer Contribution:</strong> {plan.employer_contribution}%</p>
//             <p><strong>Employee Only Plan Cost</strong> ${plan.cost_employee_only}</p>
//             <p><strong>Employee + Spouse Plan Cost</strong> ${plan.cost_employee_spouse }</p>
//             <p><strong>Employee + Children Plan Cost</strong> ${plan.cost_employee_children}</p>
//             <p><strong>Family Plan Cost</strong> ${plan.cost_family}</p>
            
//         </div>
//     );

//     if (loading) return <p>Loading benefit plans...</p>;
//     if (error) return <p className="error">{error}</p>;

//     return (
//         <div className="benefits-page">
//             <h2>Benefit Plans</h2>

//             {["health", "dental", "vision"].map((type) => (
//                 <div key={type} className="benefit-section">
//                     <h3>{type.charAt(0).toUpperCase() + type.slice(1)} Plans</h3>
//                     {plans[type].length > 0 ? (
//                         plans[type].map(renderPlanCard)
//                     ) : (
//                         <p className="no-plans">No {type} plans available.</p>
//                     )}
//                 </div>
//             ))}
//         </div>
//     );
// };

// export default BenefitsPage;

